module.exports = __webpack_public_path__ + "img/no-course.f80ee0ea.svg";